module.exports = __webpack_public_path__ + "img/banner3_4.e4656995.png";